<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateVisitManage.queryCondition') }}</span>
      </div>
      <el-form :inline="true" class="demo-form-inline text-left">
        <el-form-item>
          <el-input
            v-model="affiliateVisitManageInfo.conditions.ip"
            :placeholder="$t('affiliateVisitManage.selectVisitRecord')"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="_queryAffiliateVisitMethod">
            {{ $t('affiliateVisitManage.query') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px;">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('affiliateVisitManage.visitRecord') }}</span>
      </div>
      <el-table
        :data="affiliateVisitManageInfo.affiliateVisits"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="avId"
          :label="$t('affiliateVisitManage.visitId')"
          align="center"
        />
        <el-table-column
          prop="auId"
          :label="$t('affiliateVisitManage.affiliateId')"
          align="center"
        />
        <el-table-column
          prop="openId"
          :label="$t('affiliateVisitManage.visitorId')"
          align="center"
        />
        <el-table-column
          prop="userId"
          :label="$t('affiliateVisitManage.userId')"
          align="center"
        />
        <el-table-column
          prop="ip"
          :label="$t('affiliateVisitManage.ipAddress')"
          align="center"
        />
        <el-table-column
          prop="deviceId"
          :label="$t('affiliateVisitManage.deviceId')"
          align="center"
        />
        <el-table-column
          prop="userAgent"
          :label="$t('affiliateVisitManage.userAgent')"
          align="center"
        />
        <el-table-column
          prop="landingPage"
          :label="$t('affiliateVisitManage.landingPage')"
          align="center"
        />
        <el-table-column
          prop="createTime"
          :label="$t('affiliateVisitManage.createTime')"
          align="center"
        />
        <el-table-column
          :label="$t('affiliateVisitManage.operation')"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-button
              type="danger"
              size="mini"
              @click="_openDeleteAffiliateVisitModel(scope.row)"
            >
              {{ $t('affiliateVisitManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="affiliateVisitManageInfo.conditions.page"
        :page-size="affiliateVisitManageInfo.conditions.row"
        layout="total, prev, pager, next"
        :total="affiliateVisitManageInfo.total"
        style="margin-top: 20px; text-align: right;"
      />
    </el-card>

    <delete-affiliate-visit ref="deleteAffiliateVisit"></delete-affiliate-visit>
  </div>
</template>

<script>
import { listAffiliateVisit } from '@/api/affiliate/affiliateVisitApi'
import DeleteAffiliateVisit from '@/components/affiliate/deleteAffiliateVisit/deleteAffiliateVisit.vue'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AffiliateVisitManage',
  components: {
    DeleteAffiliateVisit
  },
  data() {
    return {
      loading: false,
      affiliateVisitManageInfo: {
        affiliateVisits: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          ip: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAffiliateVisits()
  },
  methods: {
    async _listAffiliateVisits() {
      this.loading = true
      try {
        const params = {
          ...this.affiliateVisitManageInfo.conditions,
          shopId: getShopId()
        }
        const res = await listAffiliateVisit(params)
        this.affiliateVisitManageInfo.affiliateVisits = res.data
        this.affiliateVisitManageInfo.total = res.total
        this.affiliateVisitManageInfo.records = res.records
        console.log(this.affiliateVisitManageInfo.moreCondition)
      } catch (error) {
        console.error('获取访问记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryAffiliateVisitMethod() {
      this.affiliateVisitManageInfo.conditions.page = 1
      this._listAffiliateVisits()
    },
    handleCurrentChange(val) {
      this.affiliateVisitManageInfo.conditions.page = val
      this._listAffiliateVisits()
    },
    _openDeleteAffiliateVisitModel(row) {
      this.$refs.deleteAffiliateVisit.open(row)
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 样式，无需自定义样式 */
</style>